var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconMenuQna(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 19,
    viewBox: "0 0 18 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icon-call-mono"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.755 13.1847L13.7708 10.8747C13.6267 10.7635 13.4469 10.7086 13.2653 10.7203C13.0836 10.732 12.9124 10.8096 12.7838 10.9384L11.1998 12.5232C11.0818 12.6424 10.9271 12.7182 10.7606 12.7385C10.5941 12.7588 10.4257 12.7223 10.2825 12.6349C9.77254 12.3222 8.91904 11.7162 7.85104 10.6474C6.78304 9.58018 6.17704 8.72593 5.86429 8.21668C5.77682 8.07365 5.74032 7.90523 5.76075 7.73882C5.78118 7.57241 5.85732 7.41781 5.97679 7.30018L7.56079 5.71543C7.68981 5.58688 7.76742 5.41561 7.77903 5.23385C7.79063 5.05209 7.73542 4.87235 7.62379 4.72843L5.31454 1.74343C4.78954 1.06618 3.79954 0.958931 3.15454 1.52518C2.30479 2.27068 1.28404 3.38743 0.987043 4.64068C0.449293 6.89818 1.29904 9.73093 5.03404 13.4659C8.76904 17.2002 11.6018 18.0507 13.8585 17.5137C15.1118 17.2152 16.2293 16.1937 16.9748 15.3447C17.5403 14.6997 17.433 13.7097 16.755 13.1847Z",
    fill: "#989BA2"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconMenuQna);
export default __webpack_public_path__ + "static/media/icon_menu_qna.f483593f123809d00e8b4215deeb0125.svg";
export { ForwardRef as ReactComponent };